export default function getCookieDomain() {
    if (window.location.hostname.split('.').length === 2) {
        return '.' + window.location.hostname;
    }

    if (window.location.hostname.split('.')[1] !== 'scribbr') {
        return window.location.hostname;
    }

    // removes sub domain part
    return '.' + window.location.hostname.split('.').splice(1).join('.');
}
